import cobrowseIO from "cobrowse-sdk-js";
import type { FC } from "react";

import { LS_KEYS } from "@core/core.constants";

const NOT_CONNECTED_USER = "NOT_CONNECTED";

export const CobrowseIntegration: FC = () => {
  const coBrowseKey = import.meta.env.VITE_APP_COBROWSE_LICENSE_KEY;

  if (coBrowseKey) {
    const userEmail = localStorage.getItem(LS_KEYS.EMAIL) || NOT_CONNECTED_USER;
    const currentGroupRef =
      localStorage.getItem(LS_KEYS.CURRENT_GROUP_REF) || "";
    cobrowseIO.license = coBrowseKey;
    cobrowseIO.customData = {
      user_email: userEmail,
      device_id: "ECMS",
      device_name: `[ECMS] ${userEmail}`,
      group_ref: currentGroupRef,
    };
    cobrowseIO.start(coBrowseKey);
  }

  return null;
};
